<script>
    // import for modal window
    import {

        money, time, date, upcomingEvent, Action,
        home_cleanliness,
        modal, progressTime
    } from './stores.js';
    import { withActionLog } from './actionLog.js';

    export let action = new Action({});

    function onClick() {
        if (action.possible && (action.price <= $money)) {
            progressTime();
            withActionLog(action.name, action.effect);
            // TODO: fluid time
            $money -= action.price;

            $home_cleanliness -= 0.02;
            // TODO: home cleanliness -0.04 dust :)
        }
    }
</script>

{#if action.visible}
    {#if action.possible && (action.price <= $money)}
        <sl-card on:click="{onClick}">
            <strong>{action.name}</strong>
            {#if action.price > 0}<sl-badge class='price' type="info" pill>${action.price}</sl-badge>{/if}
            <br>
            <small>{action.description}</small><br>
            <small class="badges">
                {#each action.green_badges as badge}
                    <sl-badge type="success" pill>{badge}</sl-badge>
                {/each}
                {#each action.red_badges as badge}
                    <sl-badge type="danger" pill>{badge}</sl-badge>
                {/each}
            </small>
        </sl-card>
    {:else}
        <sl-card class="disabled">
            <sl-tooltip content="Not enough energy">
            <strong>{action.name}</strong>
            {#if action.price > 0}<sl-badge class='price' type="info" pill>${action.price}</sl-badge>{/if}
            <br>
            <small>{action.description}</small><br>
            <small class="badges">
                {#each action.green_badges as badge}
                    <sl-badge type="success" pill>{badge}</sl-badge>
                {/each}
                {#each action.red_badges as badge}
                    <sl-badge type="danger" pill>{badge}</sl-badge>
                {/each}
            </small>
            </sl-tooltip>
        </sl-card>
    {/if}
{/if}

<style>
    sl-card {
        margin-bottom: 0.5em;
        --padding: 0.8em;
        cursor: pointer;
        width: 100%;
    }
    sl-card strong {
        width: 100%;
        display: inline-block;
    }
    .disabled {
        color: #9ca3af;
        --sl-color-danger-500: #ffb0ab;
        --sl-color-success-500: #badea9;
    }
    .badges {
        padding-top: 0.8em;
        display: inline-flex;
        width: 100%;
        flex-wrap: wrap;
        row-gap: 0.2em;
    }
    sl-badge {
        margin-right: 0.2em;
    }
    .price {
        position: absolute;
        right: 0.6em;
    }
</style>